import type { ListKind } from "@checklist/shared";

/** Kind a template should switch to when a list section is added, or null to keep it (D11). */
export function inheritedTemplateKind(opts: {
  isNew: boolean;
  kindTouched: boolean;
  hasListSection: boolean;
  currentKind: ListKind;
  listKind: ListKind;
}): ListKind | null {
  if (!opts.isNew || opts.kindTouched || opts.hasListSection) return null;
  return opts.currentKind === "packing" && opts.listKind === "todo" ? "todo" : null;
}
